import { createContext, useState } from "react"


 const BillContext = createContext({});

 export default BillContext;